import React from "react";

interface IRenderComponent {
  isRender: boolean;
  children?: any;
}

const RenderComponent = ({ isRender, children }: IRenderComponent) => (isRender ? children : <React.Fragment> </React.Fragment>);

export default RenderComponent;
